import type { WebsiteHeaderPhotoSchema_PhotoTrioPageWidth } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_TRIO_PAGE_WIDTH_DEFAULT: WebsiteHeaderPhotoSchema_PhotoTrioPageWidth = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrioPageWidth-v1_1_1.json',
  presentationLayout: 'photoTrioPageWidth',
  photos: [],
};
